import styled from 'styled-components';
import Button from './Button';


export default styled(Button).attrs({colorTheme: 'primary'})`
  min-width: 196px;
  height: 48px;
`;
